import React, { useState } from "react";
import validator from "validator";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import AllWalletLogPositionData from "./AllWalletLogPositionData";
import financeMessage from "../../../messages/finance";

export default function AllWalletLogPosition() {
  const [showTable, setShowTable] = useState(false);
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const generateAllWalletLogPosition = () => {
    return (
      <div className="pb-4 px-2">
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گزارش مالی جایگاه</td>
                <td>قیمت (تومان)</td>
                <td>تخفیف</td>
                <td>تاربخ درج</td>
              </tr>
            </thead>
            <tbody>
              {AllWalletLogPositionData.map((item, index) => {
                return (
                  <tr>
                    <td>{helperNumbers.toPersianNum(index + 1)}</td>
                    <td>{helperNumbers.toPersianNum(item.id)}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(item.price)
                      )}
                    </td>
                    <td>
                      {item.discountID != 0 ? (
                        item.discountID
                      ) : (
                        <span className="badge badge-danger">بدون تخفیف</span>
                      )}
                    </td>
                    <td>{item.created_at}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const getPositionTagHtmlID = () => {
    const positionTagHtmlID = document
      .querySelector("#position-tag-html-id")
      .value.trim();

    if (!positionTagHtmlID) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      !positionTagHtmlID.includes(
        process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const positionID = positionTagHtmlID.replace(
      process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID,
      ""
    );

    if (!validator.isNumeric(positionID)) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return positionTagHtmlID;
  };

  const getAllScoreLogPosition = async () => {
    const positionTagHtmlID = getPositionTagHtmlID();
    if (!positionTagHtmlID) {
      return;
    }

    setShowTable(true);
  };

  return (
    <>
      <Sidebar openItem="finance" activeItem="all-wallet-log-position" />

      <div className="content-wrapper">
        <TitleBar title="گزارش مالی جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllScoreLogPosition();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="text"
                      id="position-tag-html-id"
                      class="form-control"
                      placeholder="تگ html جایگاه را وارد کنید"
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {showTable && generateAllWalletLogPosition()}
          </div>
        </section>
      </div>
    </>
  );
}
